var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueGoec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 45,
    viewBox: "0 0 39 45",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6084 37.2784C32.1755 35.3311 34.7703 33.2973 36.3773 30.5046C38.0537 27.5911 38.9941 24.1977 38.9941 20.5751C38.9941 9.7274 30.2637 0.933594 19.4941 0.933594C8.72459 0.933594 -0.00585938 9.7274 -0.00585938 20.5751C-0.00585938 25.9431 2.05907 30.8081 5.52399 34.3535L17.754 44.0111C18.4307 45.0988 19.9987 45.1137 20.6957 44.0391L29.6084 37.2784Z",
    fill: "#0345B8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.4937,
    cy: 20.1158,
    r: 16.9634,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8221 22.1905L29.2384 17.188C30.4962 21.3109 28.9909 25.9286 25.2312 28.4574C20.6261 31.5634 14.3714 30.3471 11.2647 25.7362C8.15794 21.1322 9.38139 14.8791 13.9865 11.7731C17.3338 9.51922 21.5471 9.53983 24.7845 11.4914L29.4858 8.32353C24.3652 4.03565 16.8321 3.44469 11.0172 7.3615C3.97894 12.1167 2.11629 21.6751 6.86574 28.7117C11.6152 35.7551 21.1691 37.6104 28.2074 32.869C34.414 28.6842 36.5997 20.7749 33.7748 14.1301C33.3967 13.2368 32.9294 12.364 32.3657 11.5257C31.9258 10.8729 31.4516 10.2682 30.9292 9.71162L18.8872 17.8339C17.6843 18.6447 17.3682 20.2802 18.1792 21.4827C18.9903 22.6784 20.6193 23.0013 21.8221 22.1905Z",
    fill: "#0345B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1864 18.5941L20.0497 24.3258C20.0978 24.4014 20.2009 24.4152 20.2696 24.3671L23.3767 22.2709C23.4523 22.2228 23.4661 22.1197 23.418 22.051L19.5547 16.3193C19.5066 16.2437 19.4035 16.23 19.3348 16.2781L16.2276 18.3742C16.1589 18.4223 16.1382 18.5185 16.1864 18.5941Z",
    fill: "#0345B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5711 21.5824C14.7016 21.7748 14.9695 21.8298 15.1618 21.6992L17.4901 20.1249C17.6824 19.9944 17.7374 19.7262 17.6069 19.5337C17.4764 19.3413 17.2085 19.2863 17.0162 19.4169L14.6879 20.9912C14.4956 21.1218 14.4406 21.383 14.5711 21.5824Z",
    fill: "#0345B8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.774 22.3363C16.9045 22.5287 17.1722 22.5837 17.3644 22.4531L19.6914 20.8789C19.8836 20.7483 19.9385 20.4802 19.8081 20.2877C19.6777 20.0952 19.41 20.0402 19.2178 20.1708L16.8908 21.7451C16.6917 21.8757 16.6436 22.1369 16.774 22.3363Z",
    fill: "#0345B8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6689 24.7015C16.7998 24.894 17.0684 24.949 17.2614 24.8184L19.597 23.2441C19.7899 23.1135 19.8451 22.8454 19.7141 22.6529C19.5832 22.4604 19.3145 22.4054 19.1216 22.536L16.786 24.1103C16.5862 24.2409 16.5379 24.5021 16.6689 24.7015Z",
    fill: "#0345B8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0567 18.9805L19.411 19.6881L19.7415 20.2102L18.2197 20.8284L20.6367 20.5468L20.2924 20.0247L21.6214 19.8598L21.0567 18.9805Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueGoec);
export default __webpack_public_path__ + "static/media/blueGoec.df56cf71bdb3cf86266bd0cc40e0b12a.svg";
export { ForwardRef as ReactComponent };